import {initializeFileHandler, removeFile} from './shared/uploader_utils';

let allMileageAttachments = []
let allMileageDriversFloorAttachments = []
let allMileageRearFloorAttachments = []

window.reloadMileageAttachmentUploader = () => {
  // Target the container where Cocoon inserts nested fields
  const container = document.querySelector('#mileage-files-container');

  if (!container) {
    return;
  }

  initializeMileageAttachmenttHandler('mileage-files', allMileageAttachments);
  bindMileageAttachmentRemoveEvent(container, allMileageAttachments);

  initializeMileageAttachmenttHandler('mileage-drivers-floor', allMileageDriversFloorAttachments);
  initializeMileageAttachmenttHandler('mileage-rear-floor', allMileageRearFloorAttachments);

  // Initialize MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const uploadContainer = node.querySelector('.upload-form.file-upload-area');
          const fileField = node.querySelector('input[type="file"]');
          // const previewsContainer = node.querySelector('.file-previews');
          const previewsContainer = document.querySelector('[data-preview=mileage-files-preview]');

          if (uploadContainer && fileField && previewsContainer) {
            // Small delay to ensure DOM is ready
            setTimeout(function() {
              initializeFileHandler(uploadContainer, fileField, previewsContainer, allMileageAttachments);
            }, 100);
          }
        }
      });
    });
  });

  // Start observing the container for child additions
  observer.observe(container, { childList: true, subtree: true });
}

function initializeMileageAttachmenttHandler(attachmentName, selectionList) {
  const container = document.querySelector(`#${attachmentName}-container`);
  if (!container) return;

  // Initialize handlers for existing permit file fields
  const permitFileForms = container.querySelectorAll('.nested-fields.form-card');
  
  permitFileForms.forEach(function(form) {
    const uploadContainer = form.querySelector('.upload-form.file-upload-area');
    const fileField = form.querySelector('input[type="file"]');
    // const previewsContainer = form.querySelector('.file-previews');
    const previewsContainer = container.querySelector(`[data-preview=${attachmentName}-preview]`);
    
    if (uploadContainer && fileField && previewsContainer) {
      initializeFileHandler(uploadContainer, fileField, previewsContainer, selectionList);
    }
  });
}

function bindMileageAttachmentRemoveEvent(container, selectionList) {
  container.querySelectorAll('.file-preview').forEach(filePreview => {
    filePreview.addEventListener('click', (e) => removeFile(e, selectionList));
  })
}

document.addEventListener('turbolinks:load', function() {
  reloadMileageAttachmentUploader();
});
